import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./MemberStyles.css";
import { Button } from "../ui/Button";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmText = "Delete",
  cancelText = "Cancel",
  type = "danger",
}) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialogElement = dialogRef.current;
    if (isOpen) {
      dialogElement?.showModal();
    } else {
      dialogElement?.close();
    }

    const backdropClick = (e) => {
      if (e.target === dialogElement) {
        onClose();
      }
    };

    if (dialogElement) {
      dialogElement.addEventListener("click", backdropClick);
    }

    return () => {
      if (dialogElement) {
        dialogElement.removeEventListener("click", backdropClick);
      }
    };
  }, [isOpen, onClose]);

  return (
    <dialog ref={dialogRef} className="modal-confirm" onClose={onClose}>
      <div className="modal-content-wrapper">
        <h3>{title}</h3>
        <div className="modal-body">{children}</div>
        <div className="modal-confirm-actions">
          <Button variant="primary" onClick={onClose} type="button">
            {cancelText}
          </Button>
          <Button
            className={type === "danger" ? "danger-btn" : "primary-btn"}
            onClick={onConfirm}
            type="button"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </dialog>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  type: PropTypes.oneOf(["danger", "primary"]),
};

export default ConfirmationModal;
